import { Display } from '../Display/Display';
import s from './style.module.scss';
export const AIMarksText = ['以上内容由AI生成，仅供参考', '内容由AI生成'];

const AIMarks = (props) => {
    const { text, index = 0, size = '12', style = {} } = props;
    return (
        <>
            <Display show={text}>
                <div className={s['ai-marks']} style={{ fontSize: size, ...style }}>
                    {text}
                </div>
            </Display>
            <Display show={!text}>
                <div className={s['ai-marks']} style={{ fontSize: size, ...style }}>
                    {AIMarksText[index]}
                </div>
            </Display>
        </>
    );
};
export default AIMarks;
